<template>
  <div>
    <div v-if="!items || items.length === 0">
      <p class="m-4 h4">
        No hay datos para mostrar
      </p>
    </div>
    <div v-else>
      <div
        v-for="(item, index) in items"
        :key="`${index}-${item.requestId}`"
        class="details bg-secondary-3 py-2 px-3 mb-2 rounded"
      >
        <div class="detail-col col-12 col-md-2 mb-2 mb-md-0">
          <span class="data-title">Número de Consulta</span>
          <span>{{ item.businessId }}</span>
        </div>
        <div class="detail-col col-12 col-md-2 mb-2 mb-md-0">
          <span class="data-title">Estatus</span>
          <span>{{ item.statusName }}</span>
        </div>
        <div class="detail-col col-12 col-md-2 mb-2 mb-md-0">
          <span class="data-title">Desde</span>
          <span>
            <CustomDatePicker
              v-model="item.assignmentStartDate"
              :disabled="true"
            />
          </span>
        </div>
        <div class="detail-col col-12 col-md-2 mb-2 mb-md-0">
          <span class="data-title">Hasta</span>
          <span>
            <CustomDatePicker
              v-model="item.assignmentEndDate"
              :disabled="true"
            />
          </span>
        </div>
        <div class="detail-col col-12 col-md-2 mb-2 mb-md-0">
          <ActionButton
            variant="custom-btn-return m-2 success"
            :i="`fas fa-print pr-1`"
            @click="$emit('on-download-letter', item.requestId)"
          >
            Descargar Carta de Aprobación
          </ActionButton>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDatePicker from 'custom-date-picker';
import { ActionButton } from '@/components/common';

export default {
  props: {
    items: {
      type: Array,
      default: [{ id: 0 }],
      require: true,
    },
  },
  components: {
    CustomDatePicker,
    ActionButton,
  },
  mounted() {
    this.$emit('on-visible');
  },
  methods: {
    async downloadLetter(item) {
      const requestId = item?.requestId;
    },
  },
};
</script>

<style>
.detail-col {
  display: inline-block;
}
.details {
  display: block;
}

.data-title {
  display: block;
  text-align: left;
  font: 400 14px / 28px Lato;
  letter-spacing: 0;
  color: #727272;
  word-break: break-word;
  overflow-wrap: break-word;
}
</style>
